import cx from 'classnames'
import { useState } from 'react'
import { useMeasure } from 'react-use'

import { HeaderTab } from '../../../claim-history/components/amounts/amounts'
import amountStyles from '../../../claim-history/components/amounts/amounts.module.css'
import { Checkbox } from '../../../shared/NarusMaterial'
import { useIGAO } from '../../context'
import {
  cancelledOrCompleted,
  filterItemsByStatus,
  generateParamsString,
  getDetail,
  notEditableItem,
  withDivider
} from '../../utils'
import { Issue } from '../issues'

import styles from './item.module.scss'

const statusValueMap = {
  New: 1,
  Open: 2,
  Hold: 3,
  Deferred: 4,
  Completed: 5,
  Cancelled: 6
}

export function CarePlan ({
  item,
  handleInputSubmit,
  handleBatch,
  prevItem,
  selectedIssueId,
  setSelectedIssueId
}) {
  const [ editId, setEditId ] = useState(null)
  const { filters, sort, onSort, pageData: { metadata: { trend } }, masterBatch, setMasterBatch, search } = useIGAO()
  const [ wrapperRef, { width }] = useMeasure()

  let filteredIssues = filterItemsByStatus(item.issues, filters).sort(
    (prev, next) => notEditableItem(prev) - notEditableItem(next)
  )?.filter(i => generateParamsString(i)?.toLowerCase()?.indexOf(search?.toLowerCase() || '') !== -1).sort((next, prev) => {
    const prevRow = generateParamsString(next).toLowerCase()
    const nextRow = generateParamsString(prev).toLowerCase()
    const s = search?.toLowerCase()
    const prevNameIndex = prevRow.indexOf(s)
    const nextNameIndex = nextRow.indexOf(s)
    if (prevNameIndex === -1) {
      return 1
    }
    if (nextNameIndex === -1) {
      return -1
    }
    if (prevNameIndex > nextNameIndex) {
      return 1
    } if (prevNameIndex < nextNameIndex) {
      return -1
    }
    return 0
  })

  const sortByDetails = (_item, key) => {
    return _item.sort((prev, next) => {
      const { assignee: assigneePrev, status: statusPrev } = getDetail(prev)
      const { assignee: aassingeeNext, status: statusNext } = getDetail(next)
      const values = {
        prev: key === 'assignee' ? assigneePrev : statusPrev,
        next: key === 'assignee' ? aassingeeNext : statusNext
      }
      const sortDir = sort.find((s) => s.key === key).value
      if (sortDir === 1) {
        if (key === 'assignee') {
          return values.prev.name < values.next.name ? -1 : 1
        }
        return statusValueMap[values.prev.name] - statusValueMap[values.next.name]
      }
      if (key === 'assignee') {
        return values.prev.name > values.next.name ? -1 : 1
      }
      return statusValueMap[values.next.name] - statusValueMap[values.prev.name]
    })
  }

  const sortFn = (issues, key) => {
    return issues.sort((prev, next) => {
      const sing = sort.find(s => s.key === key).value
      if (sing === -1) {
        if (prev[key] > next[key]) {
          return -1
        }
        if (next[key] > prev[key]) {
          return 1
        }
        return 0
      }
      if (sing === 1) {
        if (prev[key] < next[key]) {
          return -1
        }
        if (next[key] < prev[key]) {
          return 1
        }
        return 0
      }
      return issues
    })
  }

  const assignee = sort.find((s) => s.key === 'assignee')
  const status = sort.find((s) => s.key === 'status')
  const description = sort.find((s) => s.key === 'description')

  if (assignee.value !== 0 && filteredIssues) {
    filteredIssues = sortByDetails(filteredIssues, 'assignee')
  }
  if (status.value !== 0 && filteredIssues) {
    filteredIssues = sortByDetails(filteredIssues, 'status')
  }

  if (description.value !== 0 && filteredIssues) {
    filteredIssues = sortFn(filteredIssues, 'description')
  }

  const renderArrow = v => {
    if (v === 1) {
      return '↑'
    } if (v === -1) {
      return '↓'
    }
    return ''
  }

  const openIssues = item?.issues?.filter(i => getDetail(i).status.id === 'in-progress')
  const closedIssues = item?.issues?.filter(i => cancelledOrCompleted(i))
  const openActions = openIssues?.map(i => i.actions?.filter(a => getDetail(a).status.id === 'in-progress')).flatMap(x => x)
  const closedActions = openIssues?.map(i => i.actions?.filter(a => cancelledOrCompleted(a))).flatMap(x => x)
  const oldestAction = Math.max(
    ...item.issues.map(
      i => i.actions?.map(
        a => !cancelledOrCompleted(a) && a.dueDate
      )
    )
      .flatMap(x => x)
      .filter(it => !!it)
      .map(it => new Date(it))
  )

  const headerTabs = [{
    label: 'Closed Issues',
    value: closedIssues.length,
    color: 'orange'
  }, {
    label: 'Open Actions',
    value: openActions.length,
    color: 'purple'
  }, {
    label: 'Closed Actions',
    value: closedActions.length,
    color: 'green'
  }, {
    label: 'Oldest Action',
    value: oldestAction,
    color: 'orange'
  }]

  let size = width < 1200
    ? 'small'
    : width < 1500
      ? 'medium'
      : 'large'

  return (
    <>
      <div style={{ borderRadius: '1rem', overflow: 'hidden' }}>
        <div
          className={cx(amountStyles.amounts, amountStyles[size])}
          ref={wrapperRef}
        >
          <div className={amountStyles.tabContainer}>
            {headerTabs.map((item) => (
              <HeaderTab
                label={item.label}
                amount={item.value}
                key={item.label}
                color={item.color}
              />
            ))}
          </div>
        </div>
      </div>

      {withDivider(prevItem, filters)}

      <div
        className={cx(styles.carePlanHeader, {
          [styles.trend]: trend
        })}
      >
        <div style={{ gridArea: 'checkbox' }}>
          <Checkbox
            onChange={() => setMasterBatch((prev) => !prev)}
            value={masterBatch}
          />
        </div>
        <div style={{ gridArea: 'domain', opacity: 0, width: '26px' }} />
        <div className={styles.actions} />
        {sort.map(v => (
          <button
            style={{ gridArea: v.key, textAlign: v.align }}
            key={v.key}
            onClick={() => onSort(v.key)}
          >
            {v.name}{' '}{renderArrow(v.value)}
          </button>
        ))}
      </div>

      {filteredIssues?.length > 0 && (
        <div
          className='issue-list'
          data-cy='issue-list'
        >
          {filteredIssues?.map(issue => (
            <Issue
              key={`${issue.id}-${JSON.stringify(issue.details)}`}
              selected={selectedIssueId === issue.id}
              setSelectedIssueId={setSelectedIssueId}
              issue={issue}
              item={item}
              editId={editId}
              setEditId={setEditId}
              handleInputSubmit={handleInputSubmit}
              handleBatch={handleBatch}
            />
          ))}
        </div>
      )}
    </>
  )
}
